"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'voices.natalie.description': 'Americana amichevole e intelligente perfetta per narrazione.',
};
